<!-- Start Containerbar -->
<div id="containerbar">
  <p-toast></p-toast>
  <!-- Start Container -->
  <div class="container">
    <div class="auth-box login-box">
      <!-- Start row -->
      <div class="row no-gutters align-items-center justify-content-center">
        <!-- Start col -->
        <div class="col-md-6 col-offset-md-3">
          <!-- Start Auth Box -->
          <div class="auth-box-right">
            <div class="card">
              <div class="card-body">
                <form
                  class="login-form"
                  [formGroup]="loginForm"
                  (ngSubmit)="onLogin()"
                >
                  <div class="form-head">
                    <a class="logo"
                      ><img
                        src="assets/images/logo.svg"
                        class="img-fluid"
                        alt="logo"
                    /></a>
                  </div>
                  <h4 class="text-primary my-4">Login</h4>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="username"
                      autofocus="autofocus"
                      placeholder="Enter Email"
                      required
                      formControlName="email"
                      [ngClass]="{
                        'is-invalid': submitted && f.email.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && f.email.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.email.errors.pattern">
                        Please enter valid email address
                      </div>
                      <div *ngIf="f.email.errors.required">
                        Please enter email address
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div style="text-align: center">
                      <div class="form-group">
                        <div class="form-input">
                          <input
                            [type]="showPassword ? 'text' : 'password'"
                            class="form-control"
                            id="password-field"
                            placeholder="Enter Password"
                            required
                            formControlName="password"
                            [ngClass]="{
                              'is-invalid': submitted && f.password.errors
                            }"
                          /><span
                            class="icon btn btnple Tab"
                            style="border-style: ridge"
                            tabindex="0"
                          >
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !showPassword,
                                'fa-eye': showPassword
                              }"
                              (click)="toggleFieldTextType()"
                            ></i
                          ></span>
                        </div>
                        <div
                          *ngIf="submitted && f.password.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.password.errors.required">
                            Please enter password
                          </div>

                          <div *ngIf="f.password.errors.pattern">
                            Min 8 and Atleast 1 Upper case
                            letter, 1 Lower case letter, 1 Number & 1 Special
                            character
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row mb-3">
                    <div class="col-sm-12">
                      <div class="forgot-psw">
                        <span
                          id="forgot-psw"
                          class="btn btnple font-16 forgetpass Tab"
                          tabindex="0"
                          (click)="modeChange()"
                        >
                          Forgot Password ?
                        </span>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary-rgba btn-lg btn-block font-18"
                    [disabled]="disableBtn"
                  >
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
          <!-- End Auth Box -->
        </div>
        <!-- End col -->
      </div>
      <!-- End row -->
    </div>
  </div>
  <!-- End Container -->
</div>
<!-- End Containerbar -->
